import path from 'path'
import Vue from 'vue'
import App from './App.vue'
import Project from './components/Project.vue'
import Page from './components/Page.vue'
import Pager from './components/Pager.vue'
import PageFlipper from './components/PageFlipper.vue'
import Cross from './components/Cross.vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'

Vue.use(VueRouter)
Vue.use(VueResource)


const router = new VueRouter({
  mode: 'history',
  base: path.join(__dirname, '/') ,
  routes: [
      {
         path: '/',
         name: 'home'
      },
      { path: '/:slug',
        components: {
          default: Project,
          'page-flipper': PageFlipper,
          'cross': Cross
        },
        name:'project',
        children: [
          {
            path: '',
            redirect: '1'
          },
          {
            path: ':page',
            name:'page',
            components: {
              default: Page,
              pager: Pager
            }
          }
        ]
      }
  ]
});

Vue.url.options.root = '/api';

new Vue({
  router,
  http: {
    root: '/api'
  },
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js